import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { FileUploadService } from 'src/app/services/file-upload.service';
import { GlobalServicesService } from 'src/app/services/global-services.service';
import { SharedServicesService } from 'src/app/services/shared-services.service';
import { TalentPoolService } from 'src/app/services/talent-pool.service';
import { nanoid } from 'nanoid'
import { saveAs } from 'file-saver';
import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
    selector: 'app-invite-candidate',
    templateUrl: './invite-candidate.component.html',
    styleUrls: ['./invite-candidate.component.css'],
    providers: [MessageService],
    standalone: false
})
export class InviteCandidateComponent implements OnInit {
  @Output() inviteSent = new EventEmitter<any>()
  @Output() bulkInviteSent = new EventEmitter<any>()
  @Output() candidateMoved = new EventEmitter<any>()
  @Output() closeAddCandidate = new EventEmitter<any>()
  @Input() existingCandidates: any[] = [];
  @Input() action: string = 'invite';
  isMoveEnabled: boolean = false;

  hasExistingCandidates(): boolean {
    return Array.isArray(this.existingCandidates) && this.existingCandidates.length > 0;
  }
  
  selectedMoveEvent: any = null;
  loadingMoveCategories: boolean = false;
  loadingMoveEvents: boolean = false;
  selectedCandidateUuids: any[] = [];
  isLoading: boolean = false;
  showEditor: boolean = true;
  formModified: boolean = false;
  _selectedCategory: string = 'single-invite';
  emailPattern: any = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,24}$/;
  eventCategories: any = [];
  loadSingleInvite: boolean = false;
  loadExistingUser: boolean = false;
  userExist: boolean = false;
  cohortUploaded: boolean = false;
  uploadingFile: boolean = false;
  countDiv : boolean = false;
  clicked: boolean = false;
  eventList: any = [];
  genderList: any = [];
  sourceTypeList: any = [];
  sourceNameList: any = [];
  existingUserList: any = [];
  existingUserColumns: any = []
  cohortFileSize: any;
  requiredColumns: Array<any> = [];
  existingRequiredColumns: Array<any> = [];
  cohortFile: Array<any> = [];
  cohortFileCopy: Array<any> = [];
  errorFileData: any;
  errorFile: any;
  templateValue: Array<any> = [];
  counts: any;
  bulkValidatedData: any = [];
  existingUsers: any;
  mediaFile: File[] = [];
  loadEventList: boolean = false;
  allCategoryEvents: any;
  disableInvite: boolean = false;
  bulkEnable: boolean = false;
  messageEnable : boolean = false;
  fileMessage: any;
  fileUploadPayload : any;

  eventSearchSubject = new Subject<string>();
  currentEventPage: number = 1;
  eventPageSize: number = 10;
  hasMoreEvents: boolean = true;
  isLoadingMoreEvents: boolean = false;
  currentCategoryId: string | number | null = null;
  currentSearchTerm: string = '';
  totalEventPages: number = 1;

  currentDate = new Date();
  userPrivileges: Set<string> = new Set();
  companyId: string = '';
  schoolId: string = '';
  bulkInviteLimit: number = 5000;
  recruiterId: number | null = null;
  errorFileUrl: string | null = null;
  static ageValidator: ValidatorFn = (control: AbstractControl): { [key: string]: any } | null => {
    if (!control.value) return null;
    let dateOfBirth: Date;
    if (typeof control.value === 'string') {
      dateOfBirth = new Date(control.value);
    } else {
      dateOfBirth = control.value;
    }
    if (isNaN(dateOfBirth.getTime())) return { 'ageInvalid': true }; 
    const today = new Date();
    const birthYear = dateOfBirth.getFullYear();
    const birthMonth = dateOfBirth.getMonth();
    const birthDay = dateOfBirth.getDate();
    const currentYear = today.getFullYear();
    const currentMonth = today.getMonth();
    const currentDay = today.getDate();
    let age = currentYear - birthYear;
    if (currentMonth < birthMonth || (currentMonth === birthMonth && currentDay < birthDay)) {
      age--; 
    }
  
    return age < 14 ? { 'ageInvalid': true } : null; // Age should be at least 14
  };
  inviteForm: FormGroup = new FormGroup({
    firstName: new FormControl('',[Validators.minLength(3), Validators.maxLength(50)]),
    lastName: new FormControl('',[Validators.minLength(1), Validators.maxLength(50)]),
    email: new FormControl('', [Validators.required, Validators.pattern(this.emailPattern)]),
    mobileNumber: new FormControl(null, [Validators.pattern("^[0-9]{10}$")]),
    eventCategory: new FormControl(null, Validators.required),
    gender: new FormControl(null),
    date_of_birth: new FormControl(null, [InviteCandidateComponent.ageValidator]),
    eventName: new FormControl(null, Validators.required),
    eventId: new FormControl('', Validators.required),
    sourceType: new FormControl(null, Validators.required),
    sourceName: new FormControl(null, Validators.required),
  })

  bulkInviteForm: FormGroup = new FormGroup({
    Bucket_name: new FormControl(''),
    file_name: new FormControl(''),
    link: new FormControl(''),
    source: new FormControl('', Validators.required),
    file: new FormControl('',Validators.required),
    eventCategory: new FormControl('', Validators.required),
    eventName: new FormControl('', Validators.required),
    actionId: new FormControl('')
  })

  moveForm: FormGroup = new FormGroup({
    eventCategory: new FormControl(null, Validators.required),
    eventName: new FormControl(null, Validators.required),
    sourceType: new FormControl(null),
    sourceName: new FormControl(null),
  });

    constructor(
      private talentPoolService: TalentPoolService, 
      private messageService: MessageService,
      private fileUploadService: FileUploadService,
      private globalService: GlobalServicesService,
      private sharedServicesService: SharedServicesService,
      private http: HttpClient
      ) {
       
      this.getInviteFormData();
      this.genderList = [
        { label: 'Male', value: 'male'},
        { label: 'Female', value: 'female'},
        { label: 'Other', value: 'other'},
      ]
        
      this.existingUserColumns = [
        { field: 'firstName', header: 'First Name' },
        { field: 'lastName', header: 'Last Name' },
        { field: 'mobileNumber', header: 'Mobile Number' },
        { field: 'eventCategory', header: 'Event Category' },
        { field: 'invitedEvents', header: 'Existing Events' },
        { field: 'sourceType', header: 'Source Type' },
        { field: 'sourceName', header: 'Source Name' },
      ]

      this.requiredColumns = [
        { field: 'firstName', header: 'First Name' },
        { field: 'lastName', header: 'Last Name' },
        { field: 'email', header: 'Email' },
        { field: 'countryCode', header: 'Country Code' },
        { field: 'mobileNumber', header: 'Mobile Number' },
        { field: 'eventCategory', header: 'Event Category' },
        { field: 'invitedEvents', header: 'Existing Events' },
        { field: 'eventName', header: 'Event Name' },
        { field: 'eventId', header: 'Event ID' },
        { field: 'sourceType', header: 'Source Type' },
        { field: 'sourceName', header: 'Source Name' },
        ]

      this.existingRequiredColumns = [
        { field: 'firstName', header: 'First Name' },
        { field: 'lastName', header: 'Last Name' },
        { field: 'email', header: 'Email' },
        { field: 'countryCode', header: 'Country Code' },
        { field: 'mobileNumber', header: 'Mobile Number' },
        { field: 'eventCategory', header: 'Event Category' },
        { field: 'eventName', header: 'Event Name' },
        { field: 'eventId', header: 'Event ID' },
        { field: 'sourceType', header: 'Source Type' },
        { field: 'sourceName', header: 'Source Name' },
        ]
     }
  getInviteFormData = async () => {
    this.talentPoolService.getCandidateInviteFormDataFastApi().subscribe({
      next: (res: any) => {
        if (res.status === 200) {
          const mapForms = (forms: any[]) => forms.map((element: any) => ({
            label: element.name,
            value: element.id,
          }));
          const eventCategories = res.body.event_categories || [];
          this.eventCategories = mapForms(eventCategories);
          const sourceTypeList = res.body.candidate_source_types || [];
          this.sourceTypeList = mapForms(sourceTypeList);
          const sourceNameList = res.body.candidate_sources || [];
          this.sourceNameList = mapForms(sourceNameList);
        }
      },
      error: () => {
      }
    });
  }

    ngOnInit() {
      this.companyId = localStorage.getItem('companyUUID') ?? '';
      this.globalService.privilegeDetailsSubject.subscribe((privileges) => {
        this.userPrivileges = privileges;
      }); 
      this.globalService.userMeta$.subscribe(meta => {
        this.recruiterId = meta?.user_profile?.id || '';
      });
      this.sharedServicesService.metadata$.subscribe((metadata: any) => {
        if (metadata?.bulk_candidate_invite_limit) {
          this.bulkInviteLimit = metadata.bulk_candidate_invite_limit;
        }
      });
            if(!this.recruiterId) {
      this.globalService.getUserProfileFastApi().subscribe({
        next: (res: any) => {
          if (res.status === 200 && res.body?.auth_user_details?.id) {
            this.recruiterId = res.body.auth_user_details.id;
          }
        },
        error: (err) => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to fetch recruiter ID. Retry again.' });
        }
      });}
      // this.getAllCategoryEvents();
      this.schoolId = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details') || '{}').company_settings?.school_code : '',
      this.inviteForm.valueChanges.subscribe(() => {
        if (this.userExist) {
          this.disableInvite = false; 
        }
        this.inviteForm.valueChanges.subscribe(() => {
          this.disableInvite = false; 
        });
      });  

      this.eventSearchSubject.pipe(
        debounceTime(500),
        distinctUntilChanged()
      ).subscribe(searchTerm => {
        const trimmedValue = searchTerm.trim();
        if (trimmedValue.length === 0) {
          this.currentSearchTerm = '';
          this.searchEvents('');
        } else if (trimmedValue.length > 2) {
          this.currentSearchTerm = trimmedValue;
          this.searchEvents(trimmedValue);
        }
      });

      if (this.action === 'moveCandidate') {
        Promise.resolve().then(() => {
          this.initializeSelectedCandidates();
        });
      }

      Promise.resolve().then(() => {
        this.isMoveEnabled = this.hasExistingCandidates();
      });
    }


    initializeSelectedCandidates() {
      if (!this.existingCandidates?.length) {
        this.selectedCandidateUuids = [];
        return;
      }

      this.selectedCandidateUuids = this.existingCandidates.map(candidate => ({
        email: candidate.email,
        uuid: candidate.uuid,
        first_name: candidate.first_name || '',
        last_name: candidate.last_name || ''
      }));
    }

    formatDate(dateString: string): string {
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`; // Format: YYYY-MM-DD
    }
    sendInvite(event?: Event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      if (this.disableInvite || this.loadSingleInvite) return;
      this.disableInvite = true;
      this.loadSingleInvite = true;
      this.errorFile = null;
      
      if (!this.recruiterId) {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Recruiter ID not found' });
        return;
      }
    
      if (this._selectedCategory === 'single-invite') {
        const payload = {
          first_name: this.inviteForm.value.firstName || null,
          last_name: this.inviteForm.value.lastName || null,
          email: this.inviteForm.value.email ? this.inviteForm.value.email.toLowerCase() : null,
          gender: this.inviteForm.value.gender?.value || null,
          date_of_birth: this.inviteForm.value.date_of_birth ? this.formatDate(this.inviteForm.value.date_of_birth) : null,
          mobile_number: this.inviteForm.value.mobileNumber || null,
          candidate_source_id: this.inviteForm.value.sourceName.value,
          candidate_source_type_id: this.inviteForm.value.sourceType.value,
          recruiter_id: this.recruiterId,
        };
        this.talentPoolService.candidateSingleInviteFastApi(this.inviteForm.value.eventName.value, payload).subscribe({
          next: (res: any) => {
            this.resetInviteState();
            if (res.status === 201) {
              this.userExist = false;
              this.existingUserList = [];
              this.inviteForm.reset();
              this.disableInvite = true;
              this.messageService.add({ severity: 'success', summary: 'Success', detail: res.body.detail });
              this.inviteSent.emit({ severity: 'success', summary: 'Success', detail: res.body.detail });
              setTimeout(() => {
                this.closeAddCandidate.emit();
              }, 1000);
            } else if (res?.body?.data?.message === 'User exist in other events') {
              this.userExist = true;
              this.disableInvite = true;
              this.existingUserList = res?.body?.data?.body?.data || [];
              this.messageService.add({ severity: 'info', summary: 'Info', detail: res.body.data.message });
            } else {
              this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Something went wrong' });
              this.disableInvite = true;
            }
          },
          error: () => {
            this.resetInviteState();
            this.disableInvite = true;
          }
        });
      } else if (this._selectedCategory === 'bulk-invite') {
        if (!this.cohortUploaded) {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please upload a file to proceed!' });
          this.resetInviteState();
          return;
        }
    
        let payload = {
          file_name: this.fileUploadPayload.file_name,
          recruiter_id: this.recruiterId,
        };
    
        const eventId = this.bulkInviteForm.value.eventName?.value || this.bulkInviteForm.value.eventName;
        if (!eventId || typeof eventId !== 'string') {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Event ID is invalid' });
          this.resetInviteState();
          return;
        }
    
        this.talentPoolService.bulkInviteFastApi(payload, eventId).subscribe({
          next: (res: any) => {
            this.resetInviteState();
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Bulk Invite Sent Successfully!' });
            this.clearBulkInviteCache();
            setTimeout(() => {
              this.closeAddCandidate.emit();
            }, 1000);
          },
          error: (error: any) => {
            this.resetInviteState();
            const errorResponse = error.error;
    
            if (errorResponse?.error_file) {
              this.errorFileUrl = errorResponse.error_file;
              this.messageService.add({
                severity: 'warn',
                summary: 'Warning',
                detail: 'Some records have errors. Download the error report.',
              });
              return;
            }
            if (errorResponse.detail === "File not found") {
              this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'File not found. Please try uploading again.'
              });
              return;
            }
            if (error.status === 500) {
              this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Upload data in the provided sample format.'
              });
              return;
            }
    
    
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: errorResponse?.detail || 'Something went wrong.',
            });
          }
        });
      }
    }
    resetInviteState() {
      this.loadSingleInvite = false;
      this.disableInvite = false;
    }
    
    clearBulkInviteCache() {
      this.bulkInviteForm.reset();
      this.bulkInviteForm.controls['file'].setValue('');
      this.cohortUploaded = false;
      this.fileUploadPayload = null;
      this.bulkInviteForm.controls['eventName'].setValue('');
      this.bulkInviteForm.controls['eventCategory'].setValue('');
    }

    getAllEvents(event: any) {
      this.loadEventList = true;
      this.eventList = [];
      this.inviteForm.controls['eventName'].setValue(null);
      this.bulkInviteForm.controls['eventName'].setValue(null);
      this.inviteForm.controls['eventId'].setValue('');
      this.bulkInviteForm.controls['eventCategory'].setValue(event.value);
      let categoryId = event?.value?.value || event?.value;
      if (!categoryId || (typeof categoryId !== 'string' && typeof categoryId !== 'number')) {
          this.loadEventList = false;
          return;
      }  
      this.currentCategoryId = categoryId;
      this.currentEventPage = 1;
      this.hasMoreEvents = true;
      this.currentSearchTerm = '';

      this.loadEventsPage(categoryId, 1, '');
  }

  loadEventsPage(categoryId: string | number, page: number, searchTerm: string = '', appendToList: boolean = false) {
      const isLoadingMore = page > 1;
      if (isLoadingMore) {
          this.isLoadingMoreEvents = true;
      } else {
          this.loadEventList = true;
      }

      this.talentPoolService.getAllEventsByCategory(
          categoryId, 
          page, 
          this.eventPageSize, 
          'asc', 
          'name', 
          searchTerm, 
          'all'
      ).subscribe({
          next: (res: any) => {  
              if (res.status === 200 && res.body?.items) {
                  const events = res.body.items;
                  const mappedEvents = Array.isArray(events) && events.length > 0 
                      ? events.map((event: any) => ({
                          label: event.name,
                          value: event.uuid,
                      }))
                      : [];

                  if (appendToList) {
                      this.eventList = this.eventList.filter((item: any) => item.value !== 'LOAD_MORE');
                      this.eventList = [...this.eventList, ...mappedEvents];
                  } else {
                      this.eventList = mappedEvents.length > 0 
                          ? mappedEvents 
                          : [{ label: "No events found", value: null }];
                  }

                  this.totalEventPages = res.body.pages || 1;
                  this.hasMoreEvents = page < this.totalEventPages;
                  this.currentEventPage = page;

                  if (this.hasMoreEvents && this.eventList.length > 0 && this.eventList[0].value !== null) {
                      this.eventList.push({ 
                          label: "Loading more events...", 
                          value: 'LOAD_MORE',
                          disabled: true 
                      });
                  }
              } else {
                  if (!appendToList) {
                      this.eventList = [{ label: "No events found", value: null }];
                  }
                  this.hasMoreEvents = false;
              }
              this.loadEventList = false;
              this.isLoadingMoreEvents = false;
          },
          error: (error) => {
              if (!appendToList) {
                  this.eventList = [{ label: "No events found", value: null }];
              }
              this.loadEventList = false;
              this.isLoadingMoreEvents = false;
              this.hasMoreEvents = false;
          }
      });
  }

  searchEvents(searchTerm: string) {
      if (!this.currentCategoryId) {
          return;
      }
      this.currentEventPage = 1;
      this.hasMoreEvents = true;
      this.currentSearchTerm = searchTerm;

      this.loadEventsPage(this.currentCategoryId, 1, searchTerm, false);
  }

  loadMoreEvents() {
      if (!this.hasMoreEvents || this.isLoadingMoreEvents || !this.currentCategoryId) {
          return;
      }

      const nextPage = this.currentEventPage + 1;
      this.loadEventsPage(this.currentCategoryId, nextPage, this.currentSearchTerm, true);
  }

  onEventDropdownFilter(event: any) {
      const searchTerm = event.filter || '';
      this.eventSearchSubject.next(searchTerm);
  }

  onEventDropdownLazyLoad(event: any) {
      this.loadMoreEvents();
  }

  onEventDropdownShow(event: any) {
      setTimeout(() => {
          const dropdownPanels = document.querySelectorAll('.p-select-overlay .p-select-list-container');
          dropdownPanels.forEach(panel => {
              panel.addEventListener('scroll', this.handleDropdownScroll.bind(this));
          });
      }, 200);
  }

  onEventDropdownHide(event: any) {
      const dropdownPanels = document.querySelectorAll('.p-select-overlay .p-select-list-container');
      dropdownPanels.forEach(panel => {
          panel.removeEventListener('scroll', this.handleDropdownScroll.bind(this));
      });
  }

  handleDropdownScroll(event: any) {
      const element = event.target;
      const threshold = 100;
      
      if (element.scrollTop + element.clientHeight >= element.scrollHeight - threshold) {
          if (this.hasMoreEvents && !this.isLoadingMoreEvents) {
              setTimeout(() => {
                  if (this.hasMoreEvents && !this.isLoadingMoreEvents) {
                      this.loadMoreEvents();
                  }
              }, 300);
          }
      }
  }
  
    getEventName(eventId: string):string{
      let eventName = '';
      this.allCategoryEvents.forEach((item:any) => {
        if(item.eventId == eventId){
          eventName = item.eventTitle;
        }
      });
      return eventName;
    }

    getAllCategoryEvents = async() => {
      let techEvents = [];
      let nonTechEvents = [];

      let getTechEvents = () => {
        return new Promise((resolve, rejects) => {
          this.talentPoolService.getAllEventsByCategory('technical').subscribe(res => {
            techEvents = res?.body?.items ?? res?.body ?? res?.data ?? [];
            return resolve(techEvents)
          })
        })
      }
      let getNonTechEvents = () => {
        return new Promise((resolve, rejects) => {
          this.talentPoolService.getAllEventsByCategory('nonTechnical').subscribe(res => {
            nonTechEvents = res?.body?.items ?? res?.body ?? res?.data ?? [];
            return resolve(nonTechEvents);
          })
        })
      }

      this.allCategoryEvents = (await Promise.all([getTechEvents(), getNonTechEvents()])).flat();
    }

    restrictNumber(event: any) {
      let e: any = event || window.event; 
      let key = e.keyCode || e.which;
  
      if (key < 48 || key > 57 || event.target.value.length >= 10) {
          if (e.preventDefault) e.preventDefault();
          e.returnValue = false;
      }
    }

    //Bulk Invite
    sampleData() {
      this.talentPoolService.bulkInviteFileDownloadFastApi().subscribe({
        next: (res: any) => {
          if (res.status === 200) {
            // Create a Blob from the response body
            const blob = new Blob([res.body], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    
            // Extract the filename from Content-Disposition header
            const contentDisposition = res.headers.get('content-disposition');
            let filename = 'bulk_invite_data.xlsx';  // Default filename
    
            if (contentDisposition) {
              const matches = contentDisposition.match(/filename="(.+)"/);
              if (matches?.[1]) {
                filename = matches[1];
              }
            }
    
            saveAs(blob, filename);
          }
        },
        error: (err) => {
          console.error('Error downloading the file:', err);
        }
      });
     
    }
  
    onRemoveExcel(){
      this.cohortUploaded = false;
      this.countDiv = false;
      this.bulkEnable = false;
      this.counts = 0;
      this.cohortFile = [];
      this.cohortFileCopy = [];
      this.existingUsers = [];
      this.bulkValidatedData = [];
      this.messageEnable = false;
      this.errorFileUrl = null;  
    }

    errorReportDownload() {
      if (this.errorFileUrl) {
        window.open(this.errorFileUrl, '_blank');
      }
    }

    cohortUpload(event: any) {
      this.errorFileUrl = '';
      let file = event.addedFiles[0];
      if (!file) {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'No file selected' });
        return;
      }
    
      if (file.size > 2 * 1024 * 1024) {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'File size should be less than 2MB' });
        return;
      }
    
      const generatedFileName = this.generateFileName(file);
      const gcsFilePath = `temp/${this.companyId}/${generatedFileName}`;
    
      const payload = {
        file_path: gcsFilePath,
        bucket_type: "private",
        origin:"invite_candidate",
      };
    
      this.uploadingFile = true;
    
      this.fileUploadService.getSignedUrlGCS(payload).subscribe({
        next: (res: any) => {
          if (res?.body?.signed_url) {
            this.uploadFileToGCS(res.body.signed_url, file, payload, generatedFileName);
          } else {
            this.uploadingFile = false;
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to get signed URL' });
          }
        },
        error: () => {
          this.uploadingFile = false;
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error fetching signed URL' });
        }
      });
    }    
    
    uploadFileToGCS(signedUrl: string, file: any, payload: any,updatedName:string) {
      const updatedPayload = {
        ...payload,
        file_name: updatedName,
        recruiter_id: this.recruiterId
      };
    
      this.fileUploadService.uploadUsingSignedUrlGCS(signedUrl, file).subscribe({
        next: (response: any) => {
          if (response.status === "success") {
            this.fileUploadPayload = updatedPayload;
            this.uploadingFile = false;
            this.cohortUploaded = true;
            this.messageService.add({ severity: 'success', summary: 'Success', detail: "File uploaded." });
          }
        },
        error: (error) => {
          this.uploadingFile = false;
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error uploading file.' });
        }
      });
    }
    generateFileName(file: any): string {
      let fileName = file.name.split(".");
      let fileExtension = fileName.pop();
      const timestamp = new Date().getTime();
      return `${fileName.join("").replace(/\s/g, "").replace(/[^\w\s]/gi, '')}_${timestamp}.${fileExtension}`;
    }    

    removeUploadedFile() {
      this.cohortUploaded = false;
      this.fileUploadPayload = null;
      this.messageService.add({ severity: 'info', summary: 'File Deleted', detail: 'Uploaded file has been removed' });
    }
    eventChange(event: any) {
      this.inviteForm.controls['eventId'].setValue(event.value);
      this.bulkInviteForm.controls['eventName'].setValue(event.value);
    }

    moveToSelectedEvent() {
      const isValid = this.moveForm.valid && 
                     this.selectedCandidateUuids.length > 0 && 
                     this.moveForm.get('eventName')?.value?.value;

      if (!isValid) {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Please fill all required fields'
        });
        return;
      }

      const payload = {
        candidate_uuids: this.selectedCandidateUuids.map(candidate => candidate.uuid),
        recruiter_id: this.recruiterId,
        candidate_source_id: this.moveForm.get('sourceName')?.value?.value || null,
        candidate_source_type_id: this.moveForm.get('sourceType')?.value?.value || null,
      };

      this.isLoading = true;
      this.talentPoolService.moveCandidatesFastApi(this.moveForm.get('eventName')?.value?.value, payload)
        .subscribe({
          next: (response: any) => {
            if (response.status === 201) {
              this.messageService.add({
                severity: 'success',
                summary: 'Success', 
                detail: 'Candidates invited successfully'
              });
              this.candidateMoved.emit({ 
                severity: 'success', 
                summary: 'Success', 
                detail: response.body.detail 
              });

              this.moveForm.reset();
              this.clicked = false;
              this.selectedCandidateUuids = [];
              setTimeout(() => {
                this.closeAddCandidate.emit();
              }, 1000);
            }
            this.isLoading = false;
          },
          error: () => {
            this.isLoading = false;
          }
        });
    }

    onSelectedCandidatesChange(event: any) {
      Promise.resolve().then(() => {
        this.selectedCandidateUuids = event.value.map((candidate: any) => ({
          uuid: candidate.uuid,
          email: candidate.email,
          first_name: candidate.first_name,
          last_name: candidate.last_name
        }));

        this.isMoveEnabled = this.selectedCandidateUuids.length > 0;
      });
    }

    removeCandidate(candidate: any) {
      const index = this.selectedCandidateUuids.findIndex(c => c.uuid === candidate.uuid);
      if (index > -1) {
        this.selectedCandidateUuids = [...this.selectedCandidateUuids];
        this.selectedCandidateUuids.splice(index, 1);
        this.onSelectedCandidatesChange({
          value: this.selectedCandidateUuids
        });
      }
    }
}
